/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import _ from 'underscore';
import DnDHandler from './DnDHandler';

class ExploreContainerDnDHandler extends DnDHandler {
	constructor(options) {
		super(options);
		this.dashboardApi = options.dashboardApi;
		this.addFragment = options.addFragment;
		this.fragmentParentId = options.fragmentParentId;
		this.exploreVM = options.exploreVM;
		this.glassContext = options.glassContext;
	}

	accepts(dragObject) {
		if (this.isPinObject(dragObject)) {
			const liveWidgets = this.getPinWidgets(dragObject);

			//When the dragged pin has only one vis and it is showing marketing page (i.e. showing startingpoints
			//and no active source selected yet), accepts and does adding a new card for the pinned vis
			if(
				liveWidgets.length === 1 &&
				this.exploreVM.isStartingPointsDisplayed() &&
				!this.exploreVM.activeDataSourceModule
			) {
				return true;
			}

			return liveWidgets.length > 1;
		}
		return false;
	}

	onDrop(dragObject) {
		return this.getSpecfromPin(dragObject, this.dashboardApi)
			.then(spec => this._addFragment(spec));
	}

	_addFragment(spec) {
		const payloadData = {
			undoRedoTransactionId: _.uniqueId('exploreContainerDnDHandler')
		};
		const options = {
			insertBefore: null,
			parentId: this.fragmentParentId,
			model: spec
		};
		return this.addFragment(options, 'exploreContainerDnDHandler', payloadData);
	}
}

export default ExploreContainerDnDHandler;


// WEBPACK FOOTER //
// ./src/js/util/ExploreContainerDnDHandler.js